export default {
      id: "ic-plan-coursdeau-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-coursdeau-usage",
      toString: function () {
        return this.url;
      }
    }